<template>
    <form class="flex flex-col gap-5" @submit.prevent="submit">
        <div class="relative">
            <label class="block text-sm font-medium leading-5 text-gray-700" for="email">{{ $t('Email') }}</label>
            <input
                id="email"
                v-model="user.email"
                :placeholder="$t('Email')"
                class="form-input block w-full mt-1 sm:text-sm sm:leading-5"
                required
                type="text"
            />
        </div>
        <div class="pt-2">
            <button id="submit-recover" class="btn-stage-primary min-h-[3rem] w-full justify-center" data-style="zoom-in" type="submit">
                {{ $t('Send account recovery email') }}
            </button>
        </div>
        <div class="flex flex-col gap-3 pt-1.5">
            <p class="text-[0.95rem] leading-[1.6] text-ink">
                {{ $t('Do you already have access to your account?') }}<br>
                <router-link class="font-semibold text-[#202830] no-underline hover:text-[#14191f]" to="/auth/login">
                    {{ $t('Sign In') }}
                </router-link>
            </p>
        </div>
    </form>
</template>

<script>
export default {
    name: "recover",
    metaInfo() {
        return {
            title: this.$i18n.t('Recover account')
        }
    },
    data() {
        return {
            user: {
                email: null,
                captcha: null
            }
        }
    },
    methods: {
        submit() {
            const self = this;
            if (self.$store.state.settings.recaptcha_enabled) {
                self.$recaptcha('recover').then(function (token) {
                    self.user.captcha = token;
                    self.recover();
                });
            } else {
                self.recover();
            }
        },
        recover() {
            const self = this;
            const ladda = Ladda.create(document.querySelector('#submit-recover'));
            ladda.start();
            axios.post('api/auth/recover', this.user).then(function () {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('An email has been sent with a link to reset the password').toString(),
                    type: 'success'
                })
                self.$router.push('/auth/login');
            }).catch(function () {
                self.user.email = null;
            });
        }
    }
}
</script>
